import { createContext } from 'react';

export const SegmentPortalContext = createContext<HTMLElement | null | undefined>(undefined);
